import { render } from "./TabPanel.vue?vue&type=template&id=039b5958"
import script from "./TabPanel.vue?vue&type=script&lang=js"
export * from "./TabPanel.vue?vue&type=script&lang=js"

import exportComponent from "E:\\backup\\Vue\\NK\\Register_studen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__